// import 'regenerator-runtime/runtime';
import Swup from "swup";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupProgressPlugin from "@swup/progress-plugin";
import WebFont from "webfontloader";
import "lazysizes";
import "lazysizes/plugins/native-loading/ls.native-loading";
import Flickity from "flickity";
import "flickity-fade";
import ScrollReveal from "scrollreveal";
import InfiniteScroll from "infinite-scroll";
import "./components/fitvids";
// import './plugins/picturefill.min';

let state = {
  navOpen: false,
  logoHidden: false,
  logoReverse: false,
  flkty: {},
  infScroll: {},
};

jQuery(() => {
  // Helpers

  const isPhone = () => {
    return window.screen.width < 768 && navigator.maxTouchPoints === 1;
  };

  const toggleBranding = (test) => {
    state.logoHidden = test;
    if (state.logoHidden) {
      jQuery("body").addClass("scrolling");
    } else {
      jQuery("body").removeClass("scrolling");
    }
  };

  const loadVimeoVideo = function (vimeo_id, player_id) {
    const options = {
      id: vimeo_id,
      width: 1280,
      loop: true,
      autoplay: true,
      mute: true,
      background: true,
      controls: false,
      quality: "4k",
      responsive: true,
    };

    const player = new Vimeo.Player(player_id, options);

    player.setVolume(0);
  };

  // Main

  const initSite = () => {
    WebFont.load({
      timeout: 3000,
      custom: {
        families: ["Cinetype"],
      },
      active: () => {
        sessionStorage.setItem("fonts", true);
      },
    });
  };

  const toggleNav = () => {
    jQuery("body").toggleClass("nav-active");
    if (!state.navOpen) {
      jQuery(".burger").attr("aria-expanded", "true");
    } else {
      jQuery(".burger").attr("aria-expanded", "false");
    }
    state.navOpen = !state.navOpen;
  };

  // Project filtering

  function animate(elem, animation) {
    return new Promise((resolve, reject) => {
      // Animation end handler
      function handleAnimationEnd() {
        resolve(elem);
      }
      elem.addEventListener("animationend", handleAnimationEnd, { once: true });
      elem.classList.add(animation);
    });
  }

  const projectFilter = {};

  async function filterProjects() {
    const target = document.querySelector(".archive-list");
    // fadeout wrapper
    await animate(target, "fade-out");

    document.querySelectorAll(".project-item").forEach(function (element) {
      element.classList.remove("hidden");

      if (projectFilter.work && !element.classList.contains("work-" + projectFilter.work)) {
        element.classList.add("hidden");
      }
      if (projectFilter.sector && !element.classList.contains("sector-" + projectFilter.sector)) {
        element.classList.add("hidden");
      }
    });

    const results = document.querySelectorAll(".project-item:not(.hidden)").length;
    console.log(results);

    if (results === 0) {
      jQuery(".archive-list").addClass("no-results");
    } else {
      jQuery(".archive-list").removeClass("no-results");
    }

    // show no results message if none showing

    // show filtered results
    target.classList.remove("fade-out");
    await animate(target, "fade-in");
    target.classList.remove("fade-in");
  }

  const filterFunctions = function () {
    document.querySelectorAll(".filter-sector").forEach((elem) => {
      elem.addEventListener("click", function () {
        jQuery(".filter-sector").removeClass("active");
        if (projectFilter.sector === jQuery(this).data("sector")) {
          delete projectFilter.sector;
        } else {
          projectFilter.sector = jQuery(this).data("sector");
          elem.classList.add("active");
        }

        this.blur();
        filterProjects();

        // return false;
      });
    });

    document.querySelectorAll(".filter-work").forEach((elem) => {
      elem.addEventListener("click", function () {
        jQuery(".filter-work").removeClass("active");
        if (projectFilter.work === this.dataset.work) {
          delete projectFilter.work;
        } else {
          projectFilter.work = this.dataset.work;
          elem.classList.add("active");
        }

        this.blur();
        filterProjects();

        // return false;
      });
    });

    if (document.querySelector(".reset-filters")) {
      document.querySelector(".reset-filters").addEventListener("click", function () {
        delete projectFilter.work;
        delete projectFilter.sector;
        jQuery(".filter-work").removeClass("active");
        jQuery(".filter-sector").removeClass("active");
        this.blur();
        filterProjects();
      });
    }
  };

  const pageMount = () => {
    filterFunctions();

    if (document.querySelector(".vimeo-player")) {
      const vimeo_id = document.querySelector(".vimeo-player").dataset.vid;
      const player_id = document.querySelector(".vimeo-player").id;
      loadVimeoVideo(vimeo_id, player_id);
    }

    window.matchMedia("(orientation: landscape)").onchange = function (event) {
      if (window.matchMedia("(max-width: 1024px)").matches && state.navOpen) {
        toggleNav();
      }
    };

    if (document.querySelector(".arrow")) {
      jQuery('.arrow[aria-role="button"]').on("click", () => {
        const movealong = document.querySelector(".st");
        if (movealong) {
          const yCoordinate = movealong.getBoundingClientRect().top + window.pageYOffset;
          const yOffset = document.getElementById("site-header").offsetHeight;

          window.scrollTo({
            top: yCoordinate - yOffset,
            behavior: "smooth",
          });
        }
      });
    }

    const slideUp = {
      opacity: 0,
      viewOffset: {
        bottom: 166,
      },
      duration: 666,
      interval: 166,
    };

    ScrollReveal().reveal(".slideup", slideUp);

    const switchBrandColor = (brandstyle) => {
      const logo = document.querySelector(".main-header");
      if (brandstyle === "text-white") {
        logo.classList.add(brandstyle);
      } else {
        logo.classList.remove("text-white");
      }
    };

    jQuery(".menu-item-has-children a").on("click", (e) => {
      const jQuerytopLink = jQuery(e.target);
      // console.log(e);
      if (jQuerytopLink.attr("aria-expanded") === "true") {
        jQuerytopLink.attr("aria-expanded", false);
        jQuerytopLink.parent().find(".sub-menu").slideUp(300);
      } else {
        jQuerytopLink.attr("aria-expanded", true);
        jQuerytopLink.parent().find(".sub-menu").slideDown(300);
      }
      e.preventDefault();
    });

    const slider = document.querySelector(".carousel");
    if (slider) {
      if (document.querySelectorAll(".carousel .slide").length > 1) {
        const options = {
          cellSelector: ".slide",
          resize: true,
          fade: true,
          prevNextButtons: false,
          pageDots: false,
          autoPlay: 3000,
          draggable: false,
          // lazyLoad: 2,
          setGallerySize: false,
          pauseAutoPlayOnHover: true,
        };
        const flkty = new Flickity(slider, options);
        slider.classList.add("loaded");
      }
    }

    const blogroll = document.querySelector(".blogroll");
    if (blogroll) {
      state.infScroll = new InfiniteScroll(blogroll, {
        path: ".pagination .next a",
        append: ".hentry",
        history: false,
        scrollThreshold: 400,
        hideNav: ".blog-pagination",
        status: ".page-load-status",
      });
    }
  };

  const swup = new Swup({
    cache: true,
    elements: ["#swup"],
    plugins: [
      new SwupPreloadPlugin(),
      new SwupBodyClassPlugin(),
      new SwupProgressPlugin(),
      new SwupScrollPlugin({
        doScrollingRightAway: false,
        animateScroll: false,
      }),
    ],
  });

  swup.hooks.on("animation:out:end", () => {
    state.navOpen = false;
    jQuery("body").removeClass("nav-active");
    jQuery(".burger").attr("aria-expanded", "false");
  });

  swup.hooks.on("content:replace", () => {
    pageMount();
    if (document.querySelector(".blogroll")) {
      state.infScroll.destroy();
      state.infScroll = {};
    }
  });

  document.addEventListener("scroll", () => {
    // console.log( jQuery('.main-header').height() );
    const triggerHeight = jQuery("body").hasClass("has-banner")
      ? jQuery(".banner").height() - jQuery(".main-header").outerHeight()
      : 0;

    toggleBranding(window.scrollY > triggerHeight);
  });

  const navbar = document.querySelector(".modal-nav");

  jQuery(".burger").on("click", () => {
    toggleNav();
  });

  initSite();
  pageMount();
});
